import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { DesignService } from '../../../services/index';

@Component({
    selector: 'add-edit-design-window',
    templateUrl: './addEditDesign.component.html'
})
export class AddEditDesignComponent implements OnInit {
    public title: string;
    public mode: string;
    public list: any[] = [];
    public designdata: any[] = [];

    // trigger-variable for Ladda
    isLoading: boolean = false;
    @Output() designLoadEvent = new EventEmitter();

    constructor(private designService: DesignService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#Design_name').focus();
        }, 100);
    }

    onSaveDesign(): void {
        let that = this;
        this.isLoading = true;
        this.designService
            .addUpdateDesign(this.designdata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.designLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/design/addEditDesign.component.ts